import axios from 'axios';

export default (id, payload) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}discount-package-catalogs/${id}`, payload)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
